import regionRepository from "../repositories/RegionRepository";

export class RegionService {
  static GetRegions(instance) {
    const repo = new regionRepository;
    return repo.getRegions(instance).then();
  }

  static GetRegionStates(instance, regionId) {
    const repo = new regionRepository;
    return repo.getRegionStates(instance, regionId).then();
  }
}